import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import CustomTabs from '../../../shared/CustomTabs';
import { InPatientVisitsFormsTabs } from '../../../constants/VisitsConstants';
import PageHeader from '../../../shared/PageHeader';
import { FaClipboardList } from 'react-icons/fa';

function NewFormsTab({ patient }) {
  const naviagte = useNavigate();
  const { state } = useLocation();
  const patientData = state?.patientData || null;
  const visitData = state?.visitData || null;

  return (
    <div className='main-page-container !overflow-y-auto scrollbar !p-0'>
      {/* <PageHeader title={'Form Entries'} Icon={FaClipboardList} iconSize={20} /> */}
      <div className='w-full h-full'>
        <CustomTabs
          {...InPatientVisitsFormsTabs({
            createEntryProps: { visitData, patient },
            viewEntriesProps: { patient, visitData }
          })}
        />
      </div>
    </div>
  );
}

export default NewFormsTab;
